import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import TemplateEdit from './TemplateEdit';
import TemplatesList from './TemplatesList';

interface WhatsAppDialogProps {
  open: boolean;
  onClose: () => void;
}

const WhatsAppDialog: React.FC<WhatsAppDialogProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const [templateId, setTemplateId] = useState<string>('');

  const handleClose = () => {
    if (templateId) {
      setTemplateId('');
    } else {
      onClose();
    }
  };

  return (
    <Dialog
      className="whatsapp-dialog"
      fullScreen
      open={open}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: '#E7ECF1',
          borderRadius: { xs: '0', sm: '16px' },
          padding: { xs: '20px', sm: '40px', md: '60px' },
          boxSizing: 'border-box',
          position: 'relative',
          overflow: 'hidden',
        },
      }}
    >
      {/* Фон диалога */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: { xs: '100%', md: '350px' },
          height: '100%',
          backgroundImage: 'url(/assets/client/background.svg)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'left center',
          opacity: 0.5,
          zIndex: 0,
        }}
      />

      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          padding: { xs: '10px', sm: '20px' },
          position: 'relative',
          zIndex: 1,
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            width: '50px',
            height: '50px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 0,
          }}
        >
          <img
            alt="close"
            src={'/assets/client/close.svg'}
            width="35"
            height="35"
            style={{ cursor: 'pointer' }}
          />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          gap: '24px',
          width: '100%',
          px: { xs: '16px', sm: '32px', md: '60px' },
          pb: { xs: '16px', sm: '32px' },
          boxSizing: 'border-box',
        }}
      >
        {templateId ? (
          <Box
            sx={{
              width: '100%',
              maxWidth: '1200px',
              mx: 'auto',
            }}
          >
            <TemplateEdit
              templateId={templateId}
              setTemplateId={setTemplateId}
            />
          </Box>
        ) : (
          <Box
            sx={{
              width: '100%',
              maxWidth: '1200px',
              mx: 'auto',
            }}
          >
            <TemplatesList setTemplateId={setTemplateId} />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default WhatsAppDialog;
